import type { RouteRecordRaw } from 'vue-router'
import { Actions, Subjects } from '@/rules/abilityTypes'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/job/:slug(.*)?',
    name: 'job',
    component: () => import('../views/JobList.vue'),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.JOB,
      action: Actions.WRITE
    }
  }
]

export default routes
